import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './avatar.scss'

const Avatar = forwardRef((props, ref) => {
	const { size, initials, image, imageSrc, className } = props

	const componentClass = 'c-avatar'
	const cssClasses = classNames(
		componentClass,
		size && `${componentClass}--size-${size}`,
		className
	)

	return (
		<div ref={ref} className={cssClasses}>
			{image ? (
				<img
					src={`${
						imageSrc === 'storage' ? process.env.STORAGE : ''
					}/${image}`}
					alt=""
				/>
			) : (
				initials
			)}
		</div>
	)
})

Avatar.propTypes = {
	initials: PropTypes.string,
	image: PropTypes.string,
	imageSrc: PropTypes.oneOf(['local', 'storage']),
	size: PropTypes.oneOf(['small', 'medium', 'large']),
	className: PropTypes.string,
}

Avatar.defaultProps = {
	initials: 'n/a',
	image: null,
	imageSrc: 'storage',
	size: null,
	className: null,
}

export default Avatar
